module.exports = __webpack_public_path__ + "img/c9bd5d06-2d1b-4e6f-a5e2-a3cdd00872ac.71ee8.71ee8641.png";